import React, { FC, useMemo } from 'react';
import { Alert, Box, Button, Link } from '@chakra-ui/react';
import { MdDownload } from 'react-icons/md';

import { Paper } from '@app/components/common';
import Logo from '@app/components/common/icons/logo';
import { chakraTheme } from '@app/styles/theme';
import { useVisitGuides } from '@app/hooks/react-native/use-visit-guides';

import { useHeader } from '../components/common/navigation/hooks/header-service';
import Video from '../components/widgets/video';
import News from '../components/widgets/news';

const HomePage: FC = () => {
  useHeader('Главная', []);

  const { variables } = useVisitGuides();

  
  const [SNEGAPP_DOWNLOAD_LINK, SNEGAPP_REQUIRED_APP_VER] = useMemo(() => {
    return [
      variables['SNEG_APP_DOWNLOAD_LINK']?.value as string,
      variables['SNEG_APP_REQUIRED_APP_VER']?.value as string,
    ];
  }, [variables]);

  return (
    <Box>
      <Box>
        <Video />
      </Box>
      <Box mt={4}>
        <Paper>
          <Box>
            <Alert status='info' display='flex' alignItems='center'>
              <Box minW={70}>
                <Logo size='middle' colorSchema={[chakraTheme.colors.brand[500], 'transparent', 'transparent']} />
              </Box>
              <Box ml={2}>
                Для установки приложения на устройство с ОС Android, на котором
                нет доступа к Google Play, можно скачать дистрибутив (версия {SNEGAPP_REQUIRED_APP_VER})
              </Box>
              <Box flex={1} ml={1} display='flex' justifyContent='flex-end'>
                <Link href={SNEGAPP_DOWNLOAD_LINK}>
                  <Button variant="solid" colorScheme='brand' size='md' iconSpacing={2} leftIcon={<MdDownload />}>
                      Скачать APK
                  </Button>
                </Link>
              </Box>
            </Alert>
          </Box>
        </Paper>
      </Box>
      <Box mt={4}>
        <News />
      </Box>
    </Box>
  );
};

export default HomePage;
